// extracted by mini-css-extract-plugin
export default {"formContainer":"auth_formContainer__p5vGP","authForm":"auth_authForm__xmNra","authTitle":"auth_authTitle__+GQpz","textError":"auth_textError__dFGr+"};